import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { GiftCard } from 'api/users'
import { GIFT_CARD_PROVIDER_IMAGES } from 'constants/giftCardProviders'
import React from 'react'
import BodyCellContainer from 'scenes/Reports/components/Table/BodyCellContainer'
import { useUserTimeZone } from 'utilities/userTimeZone'
import { formatDate } from '../helpers'
import StatusBadge from './StatusBadge'

type PropsT = {
  giftCard: GiftCard
}

const Row: React.FC<PropsT> = ({ giftCard }) => {
  const timezone = useUserTimeZone()
  const createdAt = formatDate(timezone, giftCard.created_at)
  const providerImage =
    GIFT_CARD_PROVIDER_IMAGES[giftCard.provider.toLowerCase()]

  return (
    <tr>
      <BodyCellContainer
        isLoading={false}
        isErrored={false}
        className="align-middle"
      >
        <div className="d-flex align-items-center">
          <Switch
            condition={!!providerImage}
            fallback={
              <Text.BodyText4 color="grey70">
                {giftCard.provider}
              </Text.BodyText4>
            }
          >
            <img src={providerImage} alt={giftCard.provider} width={60} />
          </Switch>
        </div>
      </BodyCellContainer>
      <BodyCellContainer className="text-right">
        <Text.BodyText4 color="grey70" className="ml-s">
          {giftCard.last4}
        </Text.BodyText4>
      </BodyCellContainer>
      <BodyCellContainer className="text-right">
        <Text.BodyText4 color="grey70" tag="div">
          {createdAt?.day}
        </Text.BodyText4>
        <Text.BodyText5 color="grey70" tag="div">
          {createdAt?.time}
        </Text.BodyText5>
      </BodyCellContainer>
      <BodyCellContainer className="text-right">
        <StatusBadge state={giftCard.state} />
      </BodyCellContainer>
    </tr>
  )
}

export default Row
